import { TranslationBundle } from "./TranslationBundle.js";
import { v4 as uuid } from 'uuid';
export class TodoItem {
    id;
    orderItemId = null;
    productId = null;
    locationId = null;
    parentProductId = null;
    courseId = null;
    note = null;
    options = null;
    addons = null;
    name = null;
    parentName = null;
    done = false;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
}
